import { render, staticRenderFns } from "./BookingsPorConfirmarPage.vue?vue&type=template&id=7f19ca91"
import script from "./BookingsPorConfirmarPage.vue?vue&type=script&lang=js"
export * from "./BookingsPorConfirmarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports